import { MutationKey } from '@shared/config';
import type { TFormErrorResponse } from '@shared/types';
import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import type { ResetPasswordRequest, ResetPasswordResponse } from '../../types';
import { authApi } from '../../authApi';
import { showNotification } from '@shared/utils';
import { useTranslation } from 'react-i18next';

export const useResetPassword = (): UseMutationResult<
  ResetPasswordResponse,
  AxiosError<TFormErrorResponse>,
  ResetPasswordRequest
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationKey: [MutationKey.RESET_PASSWORD],
    mutationFn: data => authApi.resetPassword(data),
    onSuccess: () => {
      showNotification({
        variant: 'success',
        message: t('auth.resetPasswordSuccess'),
      });
    },
  });
};
